import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Billboard, Text } from "@react-three/drei";
import { POIS } from "./poi";

function Portal({ poi }) {
  const ringRef = useRef();
  const isProjects = poi.id === "projects";

  useFrame((_, delta) => {
    if (ringRef.current) ringRef.current.rotation.z += delta * 0.4;
  });

  return (
    <group position={poi.position}>
      {/* ground glow disc marking the trigger radius */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.03, 0]}>
        <circleGeometry args={[poi.radius * 0.85, 32]} />
        <meshBasicMaterial color="#01FFFF" transparent opacity={0.06} toneMapped={false} />
      </mesh>
      {/* checkpoint portal ring — skipped in the Projects plaza so it never
          blocks clicking the hologram pedestals underneath it */}
      {!isProjects && (
        <mesh ref={ringRef} position={[0, 2.1, 0]}>
          <torusGeometry args={[2, 0.09, 8, 32]} />
          <meshBasicMaterial color="#01FFFF" toneMapped={false} />
        </mesh>
      )}
      <Billboard position={[0, isProjects ? 6.2 : 4.6, 0]}>
        <Text fontSize={isProjects ? 0.6 : 0.85} color="#01FFFF" anchorX="center" anchorY="middle" letterSpacing={0.05}>
          {isProjects ? "CLICK A PEDESTAL FOR DETAILED PROJECT" : `${poi.number} — ${poi.label}`}
        </Text>
      </Billboard>
    </group>
  );
}

export default function POIMarkers() {
  return (
    <group>
      {POIS.map((poi) => (
        <Portal key={poi.id} poi={poi} />
      ))}
    </group>
  );
}
